<template>
  <div>
    <router-view />
  </div>
</template>

<script lang="ts">
  import { defineComponent, ref } from 'vue';

  export default defineComponent({
    name: 'App',
    setup() {
    },
  });
</script>

<style lang="scss">
  html, body {
    margin: 0;
    padding: 0;
    height: 100vh;
    width: 100vw;
    box-sizing: border-box;
    background: black;
  }

  nav {
    position: absolute;
    z-index: 5;
  }

  nav ul {
    list-style-type: none;
    padding: 0;
    display: flex;
    flex-direction: row;
    background-color: #333;
  }

  nav ul li {
    margin: 0 10px;
    color: white;
  }

  nav ul li img {
    width: 30px;
    height: auto;
  }

  nav ul li a {
    color: white;
    text-decoration: none;
  }

  nav ul li a:hover,
  nav ul li:hover {
    text-decoration: underline;
  }
</style>
